import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantEmploymentDurationPage = {
  alert: {
    error: 'applicant-employment-duration-page.form.alert.error',
  },
  footer: {
    root: 'applicant-employment-duration-page.footer.root',
  },
  form: {
    h1: 'applicant-employment-duration-page.form.h1',
    h2: 'applicant-employment-duration-page.form.h2',
    radioGroupRoot: 'applicant-employment-duration-page.form.radio-group-root',
    radioOption1: 'applicant-employment-duration-page.form.radio-option1',
    radioOption2: 'applicant-employment-duration-page.form.radio-option2',
    root: 'applicant-employment-duration-page.form.root',
    submitButton: 'applicant-employment-duration-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
